module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ExclusiveServicesView.js"));
	}, "ExclusiveServicesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ExclusiveServicesView!./src/pages/Shop/Home/ExclusiveServices/ExclusiveServicesView.js
// module id = 933
// module chunks = 438